module.exports = __webpack_public_path__ + "static/media/ac.10a1d9ca.svg";